import { Component, inject } from '@angular/core';
import { GetFhirPatientSearchR4Response } from '../../../shared/model/GetFhirPatientSearchR4Response';
import { LocationCoordinates } from '../../../shared/model/LocationCoordinates';
import { AuthService } from '../../../shared/services/auth/auth.service';
import { GeolocationService } from '../../../shared/services/geolocation/geolocation.service';
import { MCAppGatewayService } from '../../../shared/services/mcappgateway/mcappgateway.service';
import { TranslateService } from '@ngx-translate/core';
import { getLocaleFromUrl } from '../../../shared/services/translate/locale-utils';
import { IdleTimeoutService } from '../../../shared/services/idletimeout/idle-timeout.service';
import { MonitoringService } from '../../../shared/services/monitoring/monitoring-service';
import { ProviderSearchResultsComponent } from "../provider-search-results/provider-search-results.component";
import { LocationSearchResultsComponent } from "../location-search-results/location-search-results.component";
import { MychartWebHeaderComponent } from "../../../shared/components/mychart-web-header/mychart-web-header.component";
import { CommonModule } from '@angular/common';
import { ProviderSearchFilterComponent } from "../provider-search-filter/provider-search-filter.component";
import { ProviderSearchDetailsComponent } from '../provider-search-details/provider-search-details.component';

@Component({
  selector: 'app-provider-location-search-results',
  imports: [CommonModule, ProviderSearchResultsComponent, ProviderSearchDetailsComponent, LocationSearchResultsComponent, MychartWebHeaderComponent, ProviderSearchFilterComponent],
  templateUrl: './provider-location-search-results.component.html',
  styleUrl: './provider-location-search-results.component.css'
})
export class ProviderLocationSearchResultsComponent {
  geolocation = inject(GeolocationService);
  mcAppGateway = inject(MCAppGatewayService);
  auth : AuthService = inject(AuthService);

  locale: string = '';
  currentLocation: LocationCoordinates | null = null;
  isMobileResolution: boolean = false;
  public title: string = 'Find a Provider';
  public eptID: string = '';
  public wprID: string = '';
  public fhirID: string = '';
  public age?: number;
  public gender?: string;
  public patientInfo: GetFhirPatientSearchR4Response | null = null;
  public patientFirstName: string | null = null;
  
  public searchMode: 'provider'| 'location' = 'provider'; 
  
  constructor(private translate: TranslateService, private idleTimeoutService: IdleTimeoutService, private monitoringService: MonitoringService) {
      this.locale = getLocaleFromUrl();
      sessionStorage.setItem("locale", this.locale);
      this.translate.use(this.locale);
  
    } 
  
    async ngOnInit() {
      this.patientFirstName = sessionStorage.getItem("patientFirstName") ?? ''; 
      // this.isMobileResolution = window.innerWidth <= 768; // Example logic for mobile resolution
  
    }
  
    toggleSearchMode(mode: 'provider' | 'location') {
      this.searchMode = mode;
    }
  
}
